import { Button, Input } from '@chakra-ui/react'
import Avatar from 'components/MainApp/Profile/Avatar'
import { useAuth } from 'hooks/auth'
import { useAddComment } from 'hooks/comments'
import React from 'react'
import { useForm } from 'react-hook-form'
import 'stylesheets/MainAppStyles/NewComment.css'


const NewComment = ({ note }) => {
    const { id: noteID } = note
    const { user, isLoading: authLoading } = useAuth();
    const { register, handleSubmit, reset } = useForm()
    const { addComment, isLoading: commentLoading } = useAddComment({ noteID, uid: user?.id })

    function handleAddComment(data) {
        addComment(data.text)
        reset()
    }

    if (authLoading) return ""
    return (
        <div className='new-comment-container'>
            <form onSubmit={handleSubmit(handleAddComment)}>
                <div className="comment-header">
                    <Avatar user={user} />
                    <Input placeholder='Write Comment...' variant="flushed" autoComplete='off' {...register('text', { required: true })} />
                </div>
                <div className="button-container">
                    <Button isLoading={commentLoading || authLoading} className='button' type='submit' colorScheme="teal">Add Comment</Button>
                </div>
            </form>
        </div>
    )
}

export default NewComment